import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router'
import {ChainSorter} from 'chainsorter';

import Filterable from '../components/ui/filter/Filterable.js';
import ReceiptForm from '../components/harvest/receiptinterface.js';
import ReceiptSummary from '../components/harvest/receipt.js';
import RecordSummary from '../components/harvest/recordsummary.js';
import Loadable from '../components/ui/loading/Loadable.js';
import Weight from '../components/ui/Weight.js';
import convert from 'convert-units';
import api from '../api/index.js';

import './Dashboard.scss'
import './ProcessorReceipts.scss'


export default (props) => {

	const [data, setData] = useState(false);
	const [processor, setProcessor] = useState(false);
	const [extraRecords, setExtraRecords] = useState(false);
	const [units, setUnits] = useState(false);
	const [redirect, setRedirect] = useState(false);

	const refresh = async () => {
		// Hit the API
		try {
			setUnits(await api.settings.get('display_units_mass'));
			let d = await api.get('harvests/receipts?processor=' + props.match.params.processor_id + '&from=' + props.dateStart.api() + '&until=' + props.dateEnd.api());

			let receipts = d['receipts'];
			ChainSorter(receipts).desc('date').sort();
			setData(receipts);

			let extra = d['unassociated_records'];
			ChainSorter(extra).desc('date').sort();
			setExtraRecords(extra);

			setProcessor(d['processor']);

		} catch(e) {
			console.log("hello", e);
			api.handleExceptions(e);
		};
	}


	const onDelete = async (recordId) => {
		try {
			await api.del('harvests/receipts/' + recordId);
			refresh();
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	useEffect(()=>{
		refresh();
	}, [props.dateStart, props.dateEnd])


	const onSaved = (a) => {
		setRedirect('/processors/' + props.match.params.processor_id + '/receipts/' + a);
		//refresh();
		//return true;
	}


	function constructString(obj, strings) {
		let out = [];
		for(let s in strings) {
			if (obj.hasOwnProperty(strings[s]))
				out.push(strings[s] + ' ' + obj[strings[s]]);
		}
		return out.join(' ');
	}

	function constructNumbers(obj, numbers) {
		let out = [];
		for(let s in numbers) {
			if (obj.hasOwnProperty(numbers[s]))
				out.push(numbers[s] + ' ' + Math.round(convert(parseFloat(obj[numbers[s]])).from('kg').to(units)));
		}
		return out.join(' ');
	}

	const filter = (data, filterstring) => {
		let filtered = [];
		let weight = 0;
		const f = filterstring.toLowerCase();

		let strings = ['ReceiptNumber', 'ProcessorID', 'Date', 'ProcessorName']
		let recordStrings = ['Date', 'InvoiceNumber', 'GradeName', 'QuotedPrice'];
		let numbers = ['Weight'];
		let recordNumbers = ['harvested'];


		for(let d in data) {
			let str = constructString(data[d], strings) + ' ' + constructNumbers(data[d], numbers);
			for(let r in data[d]['records']) {
				str += ' ' +  constructString(data[d]['records'][r], recordStrings) + ' ' + constructNumbers(data[d]['records'][r], recordNumbers);
			}
			
			if (str.toLowerCase().includes(f)) {
				filtered.push(data[d]);
				continue;
			}
		}
		return filtered;
	}

	if (redirect)
		return  <Redirect to={redirect} />

	const unassociatedWeight = extraRecords && extraRecords.reduce((a, c) => a + parseFloat(c.harvested), 0);
	let associatedWeight = 0;
	if (data) {
		for(let t = 0; t < data.length; t++) {
			for(let i = 0; i < data[t].records.length; i++) {
				associatedWeight += parseFloat(data[t].records[i].harvested);
			}
		}
	}

	return <div className="ProcessorReceipts Specific">
			<Loadable ready={data !== false} className="records">
				<h1>{ processor.Name }'s Receipts</h1>
				<div className="summary inline-weight">
					<div>{ data && 
						<Weight value={data.reduce((a, c) => a + parseFloat(c.Weight), 0)} precision="0" />
					} in Receipts</div>
					<div><Weight value={associatedWeight} precision="0" /> in Associated harvest records</div>
					<div><Weight value={unassociatedWeight} precision="0" /> in <em>Unassociated</em> harvest records</div>
				</div>
				<Filterable 
					summaryComponent={ReceiptSummary}
					addForm={ReceiptForm}
					onAddSubmit={onSaved}
					children={data}
					onSelect={false}
					type="processor receipt"
					passProps={{onDelete: onDelete, refresh: ()=>{refresh()}}}
					addProps={{processor:  parseInt(props.match.params.processor_id)}}
					filter={filter}
				/>
				<hr />
				<h3 className="inline-weight">Unassociated Harvest Records ({ extraRecords &&
					<Weight value={unassociatedWeight} precision="0" />
				})</h3>
				<div className="members">
				{
					extraRecords && extraRecords.map((r, i) => {
						return <div key={i} className="record-summary box-style">
							<RecordSummary {...r} />
						</div>;
					})
				}
				</div>
			</Loadable>
		</div>;
}